<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import RegistrationMap from '@/components(new)/UI/Maps/RegistrationMap/RegistrationMap.vue'
import { situacaoImovel, tipoPosse, documentoReformaAgraria, documentoQuilombo } from '@/libs/constants/imovel'

export default {
  components: {
    Label,
    AppDisplay,
    RegistrationMap
  },
  props: {
    imovel: {
      type: Object
    }
  },
  data () {
    return {
      loadingMapa: true
    }
  },
  async mounted () {
    setTimeout(() => {
      this.$nextTick(async () => {
        await this.init()
      })
    }, 2100)
  },
  methods: {
    async init () {
      this.$nextTick(() => {
        if (!this.$refs.registrationMapView) return
        this.$refs.registrationMapView.mapManager.map.invalidateSize()
        if (this.imovel?.geoJson?.length) {
          this.$refs.registrationMapView.addProperty({geoJsonList: this.imovel.geoJson, numerosCar: this.imovel.numerosRecibosCar})
        }
      })
      this.loadingMapa = false
    },
    formataNumeroCar (values) {
      if (!values || !values.length) return ''
      return values.map(n => `• ${n.numero}`).join('<br /> ')
    },
    formataSituacaoRegistroImovel (situacao) {
      if (!situacao) return ''
      return situacaoImovel.find(opcao => opcao.id === situacao).nome
    },

    formataTipoPosse (posse) {
      if (!posse) return ''
      return tipoPosse.find(opcao => opcao.id === posse).nome
    },
    formataDocumentoReformaAgraria (documento) {
      if (!documento) return ''
      return documentoReformaAgraria.find(opcao => opcao.id === documento).nome
    },
    formataDocumentoQuilombo (documento) {
      if (!documento) return ''
      return documentoQuilombo.find(opcao => opcao.id === documento).nome
    },
    formataMunicipioUF (municipio) {
      if (!municipio.nome || !municipio.codigoEstado) return ''
      return `${municipio.nome}/${municipio.codigoEstado}`
    }
  }
}

</script>

<template>
  <div>
    <div>
      <span class="title-imovel">Dados do imóvel</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Nome:" :content="imovel.nome" />
        <app-display v-if="imovel.possuiCar" label="Número(s) do CAR:" :content="formataNumeroCar(imovel.numerosRecibosCar)" :isContentInNextLine="true" />
      </el-col>
      <el-col :span="12">
        <app-display label="Possui CAR?" :content="imovel.possuiCar ? 'Sim' : 'Não'" />
      </el-col>
      <!-- <el-col v-if="imovel.geoJson && imovel.geoJson.length">
        <RegistrationMap
          v-loading="loadingMapa"
          ref="registrationMapView"
          class="mt-1"
          :showInfoMessage="false"
          :onlyView="true"
        />
      </el-col> -->
    </el-row>
    <div class="mt-2">
      <span class="title-imovel">Endereço do imóvel</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="CEP:" :content="imovel.endereco.cep" />
        <app-display label="Logradouro:" :content="imovel.endereco.logradouro" />
        <app-display label="Número:" :content="imovel.endereco.numero" />
      </el-col>
      <el-col :span="12">
        <app-display label="Município/UF:" :content="imovel.endereco.municipio ? formataMunicipioUF(imovel.endereco.municipio) : ''" />
        <app-display label="Comunidade ou localidade:" :content="imovel.endereco.comunidadeLocalidade" />
        <app-display label="Referência de acesso:" :content="imovel.endereco.referencia" />
      </el-col>
    </el-row>
    <div class="mt-2">
      <span class="title-imovel">Registro do imóvel</span>
      <hr />
    </div>
    <el-row>
      <div v-if="imovel.registroImovel.situacao === 'PROPRIETARIO'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
          <app-display label="Número da matrícula:" :content="imovel.registroImovel.proprietarioImovel.numeroMatricula" />
        </el-col>
      </div>
      <div v-if="imovel.registroImovel.situacao === 'POSSEIRO'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
          <app-display label="Tipo de posse:" :content="formataTipoPosse(imovel.registroImovel.posseiro.tipoPosse)" />
        </el-col>
        <el-col :span="12" v-if="imovel.registroImovel.posseiro.tipoPosse === 'OUTROS'">
          <app-display label="Especificação:" :content="imovel.registroImovel.posseiro.detalhePosse" />
        </el-col>
      </div>
      <div v-if="imovel.registroImovel.situacao === 'ASSENTADO_REFORMA_AGRARIA'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
          <app-display label="Nome do projeto de assentamento:" :content="imovel.registroImovel.assentamentoReforma.nomeProjeto" />
          <app-display label="Documento comprobatório do assentamento de reforma agrária:" :content="formataDocumentoReformaAgraria(imovel.registroImovel.assentamentoReforma.documento)" />
        </el-col>
        <el-col :span="12">
          <app-display v-if="imovel.registroImovel.assentamentoReforma.documento === 'OUTRO'" label="Especificação:" :content="imovel.registroImovel.assentamentoReforma.outrosDocumentos" />
          <app-display label="Número do documento:" :content="imovel.registroImovel.assentamentoReforma.especificacaoDocumento" />
        </el-col>
      </div>
      <div v-if="imovel.registroImovel.situacao === 'QUILOMBOLA'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
          <app-display label="Nome do quilombo:" :content="imovel.registroImovel.quilombola.nomeQuilombo" />
          <app-display label="Documento:" :content="formataDocumentoQuilombo(imovel.registroImovel.quilombola.documento)" />
        </el-col>
        <el-col :span="12">
          <app-display v-if="imovel.registroImovel.quilombola.documento === 'OUTRO'" label="Especificação:" :content="imovel.registroImovel.quilombola.outrosDocumentos" />
          <app-display label="Número do documento:" :content="imovel.registroImovel.quilombola.especificacaoDocumento" />
        </el-col>
      </div>
      <div v-if="imovel.registroImovel.situacao === 'INDIGENA'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
          <app-display label="Terra indígena:" :content="imovel.registroImovel.indigena.terra" />
        </el-col>
        <el-col :span="12">
          <app-display label="Aldeia:" :content="imovel.registroImovel.indigena.aldeia" />
          <app-display label="Povo:" :content="imovel.registroImovel.indigena.povo" />
        </el-col>
      </div>
      <div v-if="imovel.registroImovel.situacao === 'OUTROS'">
        <el-col :span="12">
          <app-display label="Situação:" :content="formataSituacaoRegistroImovel(imovel.registroImovel.situacao)" />
        </el-col>
        <el-col :span="12">
          <app-display label="Especificação:" :content="imovel.registroImovel.especificacaoOutros" />
        </el-col>
      </div>
    </el-row>
  </div>

</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Imovel/Imovel.vue